import { IconButton, Tooltip } from '@dixa/lib-shared-habla';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { askSidekick, SidekickQuestion } from 'utils/sidekick';

type SidekickDebugButtonProps = {
  /** The tooltip and accessible name of the button. */
  label: string;
  /** The prompt to send, or a question to ask the user first. */
  request: string | SidekickQuestion;
};

/** Starts a Sidekick debugging session. */
export const SidekickDebugButton = ({
  label,
  request,
}: SidekickDebugButtonProps): JSX.Element | null => {
  const flags = useFeatureFlag(['mim-sidekick']);

  if (!flags.mimSidekick) return null;

  return (
    <Tooltip wrap="span" content={label}>
      <IconButton
        variant="tertiary"
        icon="mim-sidekick"
        aria-label={label}
        onClick={() => askSidekick(request)}
      />
    </Tooltip>
  );
};
